import type { TabmenuDesignTokens } from '@primeuix/themes/types/tabmenu'

export default {
  item: {
    gap: '0.5rem',
    color: '{text.muted.color}',
    margin: '0',
    padding: '1rem 1.25rem',
    focusRing: {
      color: '{focus.ring.color}',
      style: '{focus.ring.style}',
      width: '{focus.ring.width}',
      offset: '{focus.ring.offset}',
      shadow: '{focus.ring.shadow}',
    },
    fontWeight: '600',
    hoverColor: '{text.color}',
    activeColor: '{primary.color}',
    borderColor: 'transparent',
    borderWidth: '2px 0 0 0',
    hoverBorderColor: 'transparent',
    activeBorderColor: '{primary.color}',
  },
  root: {
    transitionDuration: '{transition.duration}',
  },
  tablist: {
    background: '{content.background}',
    borderColor: '{content.border.color}',
    borderWidth: '0',
  },
  itemIcon: {
    color: '{text.muted.color}',
    hoverColor: '{text.color}',
    activeColor: '{primary.color}',
  },
  activeBar: {
    bottom: '0',
    height: '0',
    background: 'transparent',
  },
  colorScheme: {
    dark: {
      item: {
        background: '{surface.800}',
        hoverBackground: '{surface.700}',
        activeBackground: '{surface.900}',
      },
    },
    light: {
      item: {
        background: '{surface.50}',
        hoverBackground: '{surface.100}',
        activeBackground: '{surface.0}',
      },
    },
  },
} satisfies TabmenuDesignTokens
